import { useCallback, useEffect, useState } from 'react';
import {
  fetchDashboardStats,
  formatDashboardFailuresSummary,
  type DashboardModuleFailure,
  type PartialDashboardStats,
} from '@/modules/dashboard/services/dashboardStats';

export function useDashboardStats() {
  const [stats, setStats] = useState<PartialDashboardStats | null>(null);
  const [failures, setFailures] = useState<DashboardModuleFailure[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    setFailures([]);
    try {
      const result = await fetchDashboardStats();
      setStats(Object.keys(result.stats).length > 0 ? result.stats : null);
      setFailures(result.failures);
      const summary = formatDashboardFailuresSummary(result.failures);
      if (summary) {
        setError(summary);
      } else if (Object.keys(result.stats).length === 0) {
        setError('No se pudieron cargar las estadísticas.');
      }
    } catch (err) {
      console.error('[dashboard] unexpected error', err);
      setStats(null);
      setError('No se pudieron cargar las estadísticas.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  const hasStats = stats !== null && Object.keys(stats).length > 0;

  return { stats, failures, loading, error, hasStats, refresh };
}
